define('editor/edit/layers/edit/controls',['plugins/http', 'durandal/app', 'jquery', 'knockout'], function (http, app, $, ko) {
    var viewmodel = function () {
        var self = this;

        self.name = ko.observable();
        self.backup = null;

        self.activate = function (editorMapId, group, layers, backToListFunc) {
            self.editorMapId = editorMapId;
            self.group = group;
            self.backup = group;
            self.name(group.name());
            self.exit = backToListFunc;
        };
        
        self.saveCommand = function () {
            self.group.name(self.name());

            self.save()
                .then(function () {
                    self.isDirty = false;
                    self.exit();
                })
                .fail(app.showError);
        };

        self.cancelCommand = function () {
            // revert to initial layer state, for each layer
            self.group.name(self.backup.name());
            self.isDirty = false;
            self.exit();
        };

        self.save = function () {
            var url = '/api/editor/layers/group/details',
                data = {
                    editorMapId: self.editorMapId,
                    groupId: self.group.id(),
                    groupCollapsed: self.group.isCollapsed(),
                    groupName: self.group.name()
                };

            return http.post(url, data)
                .fail(app.showError);
        };
    };

    return viewmodel;
});

